module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Thin.b9611c47aa2604b7724502d6138a6776.ttf";